import React from "react";
import { IoMdClose } from "react-icons/io";
import { Box, Flex } from "rebass";
import { getLocalizedString } from "../../utils";
import { ColorTooltip } from "../common/ColorTooltip";

const ColorsSideBar = ({
  colors,
  id,
  onClose,
  forceVisible,
  offsetTop = 0,
}) => {
  function select(code) {
    forceVisible(code);
    onClose();
  }

  return (
    <Flex
      width="100vw"
      height="100vh"
      bg="#646464"
      style={{
        position: "fixed",
        top: offsetTop,
        right: "0px",
        zIndex: 4,
      }}
      flexDirection="column"
      p="10px"
    >
      <Flex
        mb="10px"
        alignItems="center"
        justifyContent="space-between"
        width="100%"
        style={{ gap: "25px" }}
      >
        <Box>
          <span
            style={{ fontSize: "14px", color: "white", fontStyle: "italic" }}
          >
            {getLocalizedString("COLORS AVAILABILITY")}
          </span>
        </Box>
        <IoMdClose color="white" size="30px" onClick={onClose} />
      </Flex>

      <div
        style={{
          display: "grid",
          gridTemplateColumns: "auto auto auto",
          gap: "10px",
        }}
      >
        {colors.map((c, i) => (
          <Flex
            key={i}
            bg="#f3f3f3"
            mb="10px"
            flexDirection="column"
            p="10px"
            alignItems="center"
            onClick={() => select(c.code)}
          >
            <span
              style={{
                fontWeight: "bold",
                whiteSpace: "nowrap",
                textOverflow: "ellipsis",
                overflow: "hidden",
                maxWidth: "95%",
              }}
            >
              {c.colorDescription}
            </span>
            <ColorTooltip
              id={id}
              rgb={c.rgb}
              colorDescription={c.colorDescription}
              code={c.code}
              componentName={"orderDetailsGrillReorderAndSwap"}
              isOrderMobile
            />
          </Flex>
        ))}
      </div>
    </Flex>
  );
};

export default ColorsSideBar;
